<script setup lang="ts">
    import { ILibraryWidget } from '@/js/services/api/library/types';
    import WidgetContent from '../widgets/WidgetContent.vue';

    interface Props {
        widget: ILibraryWidget;
        selected: boolean;
    }

    defineProps<Props>();

    const emit = defineEmits<{
        (e: 'select', id: string, selected: boolean): void;
    }>();

    const handleSelect = (id: string, event: Event) => {
        const selected = (event.target as HTMLInputElement).checked;
        emit('select', id, selected);
    };
</script>
<template>
    <div class="relative w-full px-5 pt-5 pb-15 rounded-lg border-1 border-gray-light">
        <div class="rounded-lg border-1 border-gray-light h-70 w-full mb-7">
            <WidgetContent :widget="widget" />
        </div>
        <input
            :aria-label="'select-' + widget.title"
            type="checkbox"
            class="absolute right-8 top-8"
            :checked="selected"
            @change="(e) => handleSelect(widget.id, e)"
        />
        <h1 class="text-2xl">
            {{ widget.title }}
        </h1>
        <p v-if="widget.description">
            {{ widget.description }}
        </p>
    </div>
</template>
